
export const GETLANDCONTRACT = 'GETLANDCONTRACT'
export const GETCAPSULECONTRACT = 'GETLANDCONTRACT'
export const GETRARECONTRACT = 'GETLANDCONTRACT'
export const GETASSETCONTRACT = 'GETASSETCONTRACT'
